<template>
    <div class="learn-more">

        <div class="default-effect" :style="{marginTop:marginValue+'px'}" v-show="!careerPanorama" @mouseenter="careerPanorama = true">
            <div class="btn-txt">了解详情</div>
            <div style="width: 8px;"></div>
            <div>
                <img src="../../assets/right-huang.png" style="width: 14px; height: 12px">
            </div>
        </div>
        <div class="for-more-details" :style="{marginTop:marginValue+'px'}" v-show="careerPanorama" @mouseleave="careerPanorama = false"
            @click="routeJump">
            <div class="btn-txt">了解详情</div>
            <div style="width: 8px;"></div>
            <div>
                <img src="../../assets/right.png" style="width: 14px; height: 12px">
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'learnMore',
    props:{
        urlPath: {
            type: String,
            default: '/CareerPanorama'
        },
        marginValue:{
            type: String,
            default: '26'
        }
    },
    data() {
        return {
            careerPanorama: false,
        }
    },
    methods: {
        routeJump(){
          if(this.urlPath == 'none'){
            return;
          }
          this.$router.push(this.urlPath);
        },
    }
}
</script>

<style lang="scss" scoped>
.default-effect {
    width: 116px;
    height: 38px;
    background: #FFFFFF;
    box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
    border-radius: 22px;
    border: 2px solid #FF6E00;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 459px;
    margin-top: 26px;

    .btn-txt {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #FF6E00;
        line-height: 22px;
        text-align: center;
        font-style: normal;
    }
}

.for-more-details {
    width: 120px;
    height: 42px;
    background: linear-gradient(228deg, #FF6503 0%, #FF8012 100%);
    box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 459px;
    margin-top: 26px;
    cursor: pointer;

    .btn-txt {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: center;
        font-style: normal;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LearnMore/learnMore.vue